import PortfolioInvestmentsError from '../PortfolioInvestmentsError';
class InvalidPropertyId extends PortfolioInvestmentsError {
    propertyId;
    constructor(propertyId, options) {
        super('The property id is invalid', options);
        this.propertyId = propertyId;
    }
}
export default InvalidPropertyId;
